<template>
  <div>
    <v-layout wrap justify-space-between>
      <v-flex xs8>
        <draggable
          v-model="skills"
          v-bind="dragOptions"
          @start="drag = true"
          @end="drag = false"
          tag="ul"
          class="list-group"
        >
          <transition-group type="transition" :name="!drag ? 'flip-list' : null">
            <v-card v-for="(skill, skillIndex) in skills" :key="skill.id" class="list-group-item px-2 mb-4">
              <i @click="skill.fixed = !skill.fixed" :class="skill.fixed ? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'" aria-hidden="true"></i>
              <v-layout wrap>
                <v-flex xs2>
                  <v-container fill-height fluid class="py-0">
                    <v-row align="center" justify="center" class="py-0">
                      <v-col class="py-0">
                        <div class="mb-1">
                          <v-btn fab @click="moveUp(skillIndex)" x-small elevation="0" v-if="skillIndex !== 0">
                            <v-icon small>mdi-arrow-up</v-icon>
                          </v-btn>
                          <div v-else style="padding-top:32px"></div>
                        </div>
                        <div class="mt-1">
                          <v-btn fab @click="moveDown(skillIndex)" x-small elevation="0" v-if="skillIndex !== skills.length-1">
                            <v-icon small>mdi-arrow-down</v-icon>
                          </v-btn>
                          <div v-else style="padding-top:32px"></div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-flex>
                <v-flex xs2>
                  <v-container fill-height fluid>
                    <v-row align="center" justify="center">
                      <v-col>
                        <v-icon style="cursor:move">mdi-drag-vertical</v-icon>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-flex>
                <v-flex xs8>
                  <v-container fill-height fluid>
                    <v-row align="center" justify="center">
                      <v-col>
                        <small>
                          <b>{{ getSkillName(skill) }}</b>
                        </small>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-flex>
              </v-layout>
            </v-card>
          </transition-group>
        </draggable>
      </v-flex>
      <v-flex xs4 text-center>
        <div class="mb-6">
          <v-btn @click="saveAndClose" small class="secondary">
            {{ $t('a') }}
          </v-btn>
        </div>
        <div>
          <v-btn @click="closeWithoutSaving" small outlined>
            {{ $t('b') }}
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
const allSkills = require('@/assets/app/data/allSkills.json')
import draggable from "vuedraggable";

export default {
  props: {
    mainSkills: Array
  }, 
  order: 7,
  components: {
    draggable
  },
  data: () => ({
    drag: false,
    skills: []
  }),
  mounted() {
    this.skills = JSON.parse(JSON.stringify(this.mainSkills))
  },
  methods: {
    moveUp(index) {
      this.arraymove(this.skills, index, index-1)
    },
    moveDown(index) {
      this.arraymove(this.skills, index, index+1)
    },
    arraymove(arr, fromIndex, toIndex) {
      const element = arr[fromIndex];
      arr.splice(fromIndex, 1);
      arr.splice(toIndex, 0, element);
    },
    saveAndClose() {
      this.$emit('updateMainSkillsOrder', this.skills)
    },
    closeWithoutSaving() {
      this.$emit('updateMainSkillsOrder', this.mainSkills)
    },
    getSkillName(skill) {
      if (skill.name) return skill.name
      return allSkills.find(skill1 => skill1.id === skill.id || skill1.legacyId === skill.id).name
    },
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  }
};
</script>

<style>
.button {
  margin-top: 35px;
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: move;
}

.list-group-item i {
  cursor: pointer;
}
</style>


<i18n>
{
  "fr": {
    "a": "Sauvegarder",
    "b": "Annuler"
  },
  "en": {
    "a": "Save",
    "b": "Cancel"
  }
}
</i18n>